import { useSelector } from "react-redux";

function useAuth() {
  const accessToken = useSelector((state) => state.auth?.accessToken);
  const userRole = useSelector((state) => state.auth?.role);
  const currentUserRole = useSelector((state) => state.auth?.currentRole);
  const isLogin = !!accessToken;

  return {
    isLogin,
    accessToken,
    userRole,
    currentUserRole,
  };
}

export default useAuth;
